module.exports = __webpack_public_path__ + "static/img/product-t20.b6c2d757.png";